import { formToBackEndData } from '../utils/transformer';
import { validateNIM } from '../utils/validator';

export async function submitForm(axios, formData, res) {
  try {
    validateNIM(formData.NIM);
    const matchedFormData = formToBackEndData(formData, res);
    // console.log(matchedFormData);
    const ticketPostURL = '/ticket/all/';
    const response = await axios.post(ticketPostURL, matchedFormData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (e) {
    if (e.response) {
      const errorCode = e.response.data.code;
      if (errorCode === 'submit_failed' || errorCode === 'unknown_error') {
        throw new Error('Form submission fail');
      }
    }
    throw new Error(e?.response?.data?.message);
  }
}
